import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif; 
    margin: 0;
    padding: 0;
    }

    body {
      background: ${props => props.theme.backgrounds.primaryDark};
      color: ${props => props.theme.colors.copy};
      overflow-x: hidden;
      scrollbar-width: thin;
      scrollbar-color:inherit ${props =>
        props.theme.colors.primaryBackgroundDark}  ${props =>
  props.theme.colors.complimentaryPurple};

      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-track {
        ${props => props.theme.colors.primaryBackgroundDark};
      }
      &::-webkit-scrollbar-thumb {
        background-color: ${props => props.theme.colors.complimentaryPurple};
        border-radius: 6px;
        border: 1px solid ${props => props.theme.colors.primaryBackgroundDark};
      }
    }
`;
